import Link from "next/link";
import React from "react";
import { Comments } from "../../assets";

export default function PostsRow({
  imageUrl,
  tags,
  title,
  author,
  date,
  description,
  slugUrl,
}) {
  return (
    <div className="posts_row_container">
      <div className="post_row_info">
        <span className="tags">{tags}</span>
        <div>
          <h2>{title}</h2>
          <div className="article_info">
            <span>{author}</span>
            <span>{date}</span>
          </div>
          <p>{description}</p>
        </div>
        <Link href={`/blog/${slugUrl}`} className="posts_link">
          Lire l&apos;article
        </Link>
      </div>
    </div>
  );
}
